/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InlineResponse2003ApplicationsStatus,
    InlineResponse2003ApplicationsStatusFromJSON,
    InlineResponse2003ApplicationsStatusFromJSONTyped,
    InlineResponse2003ApplicationsStatusToJSON,
    InlineResponse2003OffersModalities,
    InlineResponse2003OffersModalitiesFromJSON,
    InlineResponse2003OffersModalitiesFromJSONTyped,
    InlineResponse2003OffersModalitiesToJSON,
    InlineResponse2003OffersStatus,
    InlineResponse2003OffersStatusFromJSON,
    InlineResponse2003OffersStatusFromJSONTyped,
    InlineResponse2003OffersStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {InlineResponse2003OffersStatus}
     * @memberof InlineResponse2003
     */
    offersStatus?: InlineResponse2003OffersStatus;
    /**
     * 
     * @type {InlineResponse2003OffersModalities}
     * @memberof InlineResponse2003
     */
    offersModalities?: InlineResponse2003OffersModalities;
    /**
     * 
     * @type {InlineResponse2003ApplicationsStatus}
     * @memberof InlineResponse2003
     */
    applicationsStatus?: InlineResponse2003ApplicationsStatus;
}

export function InlineResponse2003FromJSON(json: any): InlineResponse2003 {
    return InlineResponse2003FromJSONTyped(json, false);
}

export function InlineResponse2003FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2003 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offersStatus': !exists(json, 'offers_status') ? undefined : InlineResponse2003OffersStatusFromJSON(json['offers_status']),
        'offersModalities': !exists(json, 'offers_modalities') ? undefined : InlineResponse2003OffersModalitiesFromJSON(json['offers_modalities']),
        'applicationsStatus': !exists(json, 'applications_status') ? undefined : InlineResponse2003ApplicationsStatusFromJSON(json['applications_status']),
    };
}

export function InlineResponse2003ToJSON(value?: InlineResponse2003 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offers_status': InlineResponse2003OffersStatusToJSON(value.offersStatus),
        'offers_modalities': InlineResponse2003OffersModalitiesToJSON(value.offersModalities),
        'applications_status': InlineResponse2003ApplicationsStatusToJSON(value.applicationsStatus),
    };
}


